import { mdiArrowRight } from '@mdi/js';
import Icon from '@mdi/react';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { planSelection, subscriptionInitiate } from '../../../../../helpers/datalayer-utils';
import {
  getPaymentOptionsAndPay,
  getSSOLoginUrl,
  getSSORedirectUrl,
  getSubscriptionParams,
  setUser,
} from '../../../../../helpers/subscription-helper';
import { makeApiCall } from '../../../../../helpers/utils';
import Loader from '../../../../atoms/loader';
import ShineButton from '../../../../atoms/shine-button';
import { isMobileOnly as isMobile } from 'react-device-detect';
import SubscriptionCardShimmer from '../subscription-card-shimmer';
import './subscription-plans.m.css';

const SubscriptionPlans = ({ setLoading, setActiveSubscription, setOpen, churnUser, defaultPlans = [] }) => {
  const [paymentLoader, setPaymentLoader] = useState(true);
  const [plans, setPlans] = useState(defaultPlans);
  const [isIndex, setIndex] = useState(1);
  const [amount, setAmount] = useState(defaultPlans[isIndex]?.price_cents / 100 || null);
  const [selectedPlan, setSelectedPlan] = useState(defaultPlans[isIndex] || null);
  const features = useSelector((state) => get(state, ['qt', 'config', 'features'], {}));
  const userInfo = useSelector((state) => get(state, ['userData', 'userProfile'], null));
  const active_plans = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'active_plans_id'], null),
  );
  const churn_user_plans = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'churn_user_plans_id'], null),
  );
  const integrations = useSelector((state) => get(state, ['qt', 'config', 'integrations'], null));
  const isSubscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], null));
  const isLoggedIn = useSelector((state) => get(state, ['userData', 'isLoggedIn'], null));
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null),
  );
  const [redirectUrl, setRedirectUrl] = useState('');
  const [loginUrl, setLoginUrl] = useState('');
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  useEffect(() => {
    const url = new URL(window?.location?.href);
    getSSORedirectUrl(url).then((pageUrl) => {
      setRedirectUrl(pageUrl);
    });
    const accessToken = document?.cookie
      ?.split(';')
      ?.find((c) => c.indexOf('sso_access_token') > -1);
    if (!!!accessToken) {
      setPaymentLoader(false);
    } else {
      setTimeout(() => setPaymentLoader(false), 3000);
    }
  }, []);

  useEffect(() => {
    if (isSubscriber === false) {
      makeApiCall('/subscription/get-subscription-plans').then((sp) => {
        if (sp.status) {
          let plans = sp?.data?.subscription_groups
            .map((group) => group?.subscription_plans)
            .flat(1)
            .filter((plan) => plan.enabled === true && active_plans?.includes(plan.id))
            .sort((a, b) => a.price_cents - b.price_cents);
          let churnUserPlans = sp?.data?.subscription_groups
            .map((group) => group?.subscription_plans)
            .flat(1)
            .filter((plan) => plan.enabled === true && churn_user_plans?.includes(plan.id))
            .sort((a, b) => a.price_cents - b.price_cents);
          const planList = churnUser ? churnUserPlans : plans;

          if (planList) {
            setPlans(planList);
            if (selectedPlan === null) {
              setSelectedPlan(planList[isIndex]);
            }
            if (amount === null) {
              setAmount(planList[isIndex]?.price_cents / 100);
            }
          }
          setLoading(false);
          const userSelectedPlan = JSON.parse(localStorage.getItem('USER_SELECTED_PLAN'));
          if (userSelectedPlan) {
            setSelectedPlan(userSelectedPlan);
            setAmount(userSelectedPlan?.price_cents / 100);
            planList.map((plan, index) => plan.id === userSelectedPlan.id && setIndex(index));
            const element = document.getElementById('hardpaywall');
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            });
          }
        }
      });
    }
    if (isSubscriber === true) {
      setLoading(false);
    }
  }, [isSubscriber]);

  useEffect(() => {
    if (isLoggedIn) {
      const accesstype = integrations.accesstype;
      const script = document.createElement('script');
      script.id = 'accesstype';
      script.src = `${accesstype.host}/frontend/v2/accesstype.js?key=${accesstype.accountId}${accesstype['env-sandbox'] && accesstype['env-sandbox'].enabled ? '&env=sandbox' : ''}`;
      script.async = true;
      script.defer = true;
      script.type = 'text/javascript';
      document.head.appendChild(script);
      return async () => {
        document.head.removeChild(script);
      };
    }
  }, [isLoggedIn]);

  useEffect(() => {
    getSSOLoginUrl(
      integrations?.sso?.client_id,
      integrations?.sso?.client_secret,
      redirectUrl,
      SSO_LOGIN_URL,
    ).then((pageUrl) => {
      setLoginUrl(pageUrl);
    });
  }, [redirectUrl]);

  const handlePlan = (plan, index) => {
    setIndex(index);
    setAmount(plan?.price_cents / 100);
    setSelectedPlan(plan);
  };
  const handlePayment = async () => {
    setPaymentLoader(true);
    setLoading(true);
    const params = await getSubscriptionParams(selectedPlan, userInfo);
    await setUser(userInfo);
    await getPaymentOptionsAndPay(params, 'razorpay', onPaymentSuccess, onPaymentFailure);
  };
  const onPaymentSuccess = async (subscription) => {
    await setActiveSubscription(subscription);
    await setOpen(true);
    await setPaymentLoader(false);
    setLoading(false);
  };

  const onPaymentFailure = () => {
    setLoading(false);
    setPaymentLoader(false);
  };

  const onSubscribe = async () => {
    if (paymentLoader) return;
    await localStorage.setItem('USER_SELECTED_PLAN', JSON.stringify(selectedPlan));
    window.location = loginUrl;
  };

  const subBtnText = (amount, index) => {
    const price = [1499, 3299, 5499];
    let discountedAmnt = null;

    switch (index) {
      case 0:
        discountedAmnt = price[0] - amount;
        console.log(`Amount: ${amount}, Discounted Amount: ${discountedAmnt}`);
        break;
      case 1:
        discountedAmnt = price[1] - amount;
        console.log(`Amount: ${amount}, Discounted Amount: ${discountedAmnt}`);
        break;
      case 2:
        discountedAmnt = price[2] - amount;
        console.log(`Amount: ${amount}, Discounted Amount: ${discountedAmnt}`);
        break;
      default:
        console.log('Invalid index');
    }

    return discountedAmnt;
  };

  let discountedAmnt = subBtnText(amount, isIndex);
  const isIndependenceDayActive = features?.independence_day?.active;
  const bottomStripImage = isIndependenceDayActive
    ? isMobile
      ? features?.independence_day?.paywall?.bottom_strip_mb
      : features?.independence_day?.paywall?.bottom_strip
    : null;

  return (
    <div styleName="card-section">
      {churnUser ? (
        <>
          {plans.length === 0 ? (
            <SubscriptionCardShimmer churnUser={true} isCard={true} />
          ) : (
            <div styleName="churn-user-card">
              {plans?.map((list, index) => {
                const text = list.description?.split(' ').slice(0, 2).join(' ');
                const offer_text = list?.description.match(/\d+\s+months\s+FREE/i);
                let classNames = `card ${isIndex === index ? 'select-card' : ''}`;
                return (
                  <div
                    styleName={classNames}
                    onClick={() => {
                      planSelection(userData, pageType, list.title, list.price_cents / 100);
                      handlePlan(list, index);
                    }}
                    key={index}
                  >
                    <div styleName="card-header">
                      {isIndex === index ? (
                        <img
                          src={
                            features?.independence_day?.active
                              ? '/icons/ic_radio_button_checked_org_24px.svg'
                              : '/icons/ic_radio_button_checked_24px.svg'
                          }
                          height="23px"
                          width="23px"
                        />
                      ) : (
                        <img
                          src="/icons/ic_radio_button_unchecked_24px.svg"
                          height="23px"
                          width="23px"
                        />
                      )}
                      <div styleName="card-wrap">
                        <div styleName="duration">
                          {text.toLowerCase() === 'single month' ? '1 Month' : text.toLowerCase()}
                        </div>
                        {offer_text && <div styleName="offer">{`get ${offer_text[0]}`}</div>}
                      </div>
                    </div>
                    <div styleName="card-footer">
                      <div styleName={`amount ${isIndex === index ? 'select-amt' : ''}`}>
                        ₹{list.price_cents / 100}
                      </div>
                      <div styleName="tag-amount">₹{index === 0 ? '3,299' : '5,499'}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      ) : (
        <>
          {plans.length === 0 ? (
            <SubscriptionCardShimmer isCard={true} />
          ) : (
            <div styleName="main-card">
              {plans.map((list, index) => {
                const text = list.description?.split(' ').slice(0, 2).join(' ');
                let classNames = `card ${isIndex === index ? 'select-card' : ''}`;
                if (isIndex === 1) {
                  if (index === 1) {
                    classNames += ' bg-svg-1';
                  } else if (index === 2) {
                    classNames += ' bg-svg-2';
                  }
                } else if (isIndex === 2) {
                  if (index === 1) {
                    classNames += ' bg-svg-2';
                  } else if (index === 2) {
                    classNames += ' bg-svg-1';
                  }
                } else {
                  if (index === 1 && features?.independence_day?.active) {
                    classNames += ' bg-svg-1';
                  } else if (index === 2 && features?.independence_day?.active) {
                    classNames += ' bg-svg-2';
                  }
                }
                return (
                  <div
                    styleName={classNames}
                    onClick={() => {
                      planSelection(userData, pageType, list.title, list.price_cents / 100);
                      handlePlan(list, index);
                    }}
                    key={index}
                  >
                    <div styleName="card-header">
                      {isIndex === index ? (
                        <img
                          src={
                            features?.independence_day?.active
                              ? '/icons/ic_radio_button_checked_org_24px.svg'
                              : '/icons/ic_radio_button_checked_24px.svg'
                          }
                          height="23px"
                          width="23px"
                        />
                      ) : (
                        <img
                          src="/icons/ic_radio_button_unchecked_24px.svg"
                          height="23px"
                          width="23px"
                        />
                      )}
                      {index === 1 && <div styleName="label">POPULAR</div>}
                    </div>
                    <div styleName="card-footer">
                      <div styleName={`duration ${isIndex === index ? 'select-duration' : ''}`}>
                        {text.toLowerCase() === 'single month' ? '1 Month' : text.toLowerCase()}
                      </div>
                      <div styleName={`amount ${isIndex === index ? 'select-amt' : ''}`}>
                        ₹{list.price_cents / 100}
                        <span styleName="tag-amount">
                          ₹{index === 0 ? '1,499' : index === 1 ? '3,299' : '5,499'}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}

      {isLoggedIn ? (
        <>
          <div
            onClick={() => {
              if (paymentLoader) return;
              const planSelected = [...window.dataLayer]
                .reverse()
                .find((item) => item.event === 'plan_selection');

              if (!planSelected && plans[1]) {
                planSelection(userData, pageType, plans[1].title, plans[1].price_cents / 100);
              } else if (!plans[1]) {
                console.error('No second plan available!');
              }

              subscriptionInitiate(userData, 'section-page', '', '', plans[1]?.price_cents / 100);
              handlePayment();
            }}
          >
            <ShineButton
              className={
                features?.independence_day?.active ? 'shine-button-independence' : 'shine-button'
              }
              size="medium"
              label={paymentLoader ? '' : amount ? `Continue at ₹${amount}` : 'Continue'}
              rounded="full"
              discountedAmnt={paymentLoader ? '' : discountedAmnt}
            >
              {paymentLoader ? (
                <Loader
                  height={'20px'}
                  loaderSize="small"
                  style={{
                    border: '2px solid #ffffff',
                    borderTopColor: 'transparent',
                  }}
                />
              ) : (
                <>
                  <div className="svg-wrapper" styleName="svg-wrapper">
                    <Icon path={mdiArrowRight} size={'20px'} />
                  </div>
                  {features?.independence_day?.active && (
                    <div className="discount-text">
                      You save ₹{discountedAmnt || ''} on this plan
                    </div>
                  )}
                </>
              )}
            </ShineButton>
          </div>

          <div styleName="description">
            {bottomStripImage ? (
              <img src={bottomStripImage} />
            ) : (
              'Renews automatically. Cancel anytime.'
            )}
          </div>
        </>
      ) : (
        <>
          <div onClick={onSubscribe}>
            <ShineButton
              className="shine-button"
              size="medium"
              label={paymentLoader ? '' : "Subscribe"}
              rounded={features?.independence_day?.active ? 'default' : 'full'}
              discountedAmnt={discountedAmnt}
            >
              <>
                {paymentLoader ? (
                  <Loader
                    height={'20px'}
                    loaderSize="small"
                    style={{
                      border: '2px solid #ffffff',
                      borderTopColor: 'transparent',
                    }}
                  />
                ) : ''}
                {features?.independence_day?.active && (
                  <div className="discount-text">You save ₹{discountedAmnt || ''} on this plan</div>
                )}
              </>
            </ShineButton>
          </div>
          <div styleName="description">
            {bottomStripImage ? (
              <img src={bottomStripImage} />
            ) : (
              'Renews automatically. Cancel anytime.'
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SubscriptionPlans;
